/**
 * @file XCOMM Vote related fragments.
 */

import gql from 'graphql-tag';

import { AccountDetails } from './account';
import { PhotoThumbnails } from '../../../../graphql/fragments/album';

export const FaceMatchVoteFieldDetails = gql`
  fragment FaceMatchVoteFieldDetails on FaceMatchVote {
    id
    applied
    vote
    machine_confidence
    cluster_id
    created_at
    not_sure_vote
    not_sure_flusher_count
    judge {
      ...AccountDetails
    }
    compared_face {
      id
      facebox
      photo {
        ...PhotoThumbnails
      }
      detected_race
    }
    history {
      records {
        id
        vote
        applied
        not_sure_flusher
        not_sure_maybe
        created_at
        judge {
          ...AccountDetails
        }
      }
    }
    album_photo_offset
  }
  ${AccountDetails}
  ${PhotoThumbnails}
`;

export const FaceDetails = gql`
  fragment FaceDetails on Face {
    id
    facebox
    detected_race
  }
`;
